module.exports = {
	"articleTitle1": "Builder says plans in the works for Zaragon Place 2",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Original Cottage Inn",
	"articleLink1": "https://www.michigandaily.com/content/zaragon-looks-expand-new-building-near-cottage-inn",
	"articleLink2": "https://www.michigandaily.com/section/arts/restaurant-week-guide",
	"articleSnippet1": "Apr 6, 2010 ... ... Zaragon company is looking to expand its business by building a new high-rise \nnext to the original Cottage Inn Pizza on East William Street.",
	"articleSnippet2": "Jan 12, 2016 ... With this method, you might not get to try the greatest, most original Ann ... never \nbeen there), The Original Cottage Inn and The Ravens Club.",
	"foodRecommendations": [],
	"articleTitle2": "The Michigan Daily's guide to Restaurant Week ",
	"address": "512 E William St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.277633,
		"lng": -83.742665
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/originalcottageinn.json
// module id = 938
// module chunks = 0